// extracted by mini-css-extract-plugin
export default {"wrapper":"component_wrapper__4GTzf","container":"component_container__1u+D9"};